/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media only screen and (max-width:800px){.transcription[_ngcontent-%COMP%]{flex-wrap:wrap;display:flex}}.photo-section[_ngcontent-%COMP%]{display:grid;grid-template-columns:1fr 1fr;align-content:center;grid-gap:50px;justify-items:center;align-items:center}"];
export { styles as styles };
